/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  search(params) {
    return axios.get(this.url, { params });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  phoneTransfer(conversationID, extension) {
    return axios.post(`${this.url}/${conversationID}/phone_transfer`, {
      extension,
    });
  }

  detectLanguage(conversationID, content) {
    return axios.post(`${this.url}/${conversationID}/detect_language`, {
      content,
    });
  }
}

export default new ConversationApi();
